import { Div, Button, Input } from '@codesuma/baseline'
import { Draft } from './flow'
import wizard from '../../components/wizard/index.module.css'
import style from './index.module.css'

// The one step a task needs that neither an occasion nor an event has in this
// shape: an hour, or nothing at all.
//
// Two stylesheets, the way the event page does it. The wizard's own supplies
// the scrolling body and the heading every step shares; this page's supplies
// the row below. The step edits the draft in place and emits 'change' so the
// shell can re-check the controls — the reminder step's choices depend on it.

export const WhenSlide = (draft: Draft) => {
    const base = Div()
    base.addClass(wizard.body)

    const heading = Div('ساعت مشخصی دارد؟')
    heading.addClass(wizard.stepTitle)
    base.append(heading)

    const note = Div('اگر ساعتی در نظر ندارید خالی بگذارید — کار برای همان روز می‌ماند.')
    note.addClass(style.note)
    base.append(note)

    const row = Div()
    row.addClass(style.timeRow)
    base.append(row)

    const input = Input('', 'time', { value: draft.time })
    input.addClass(style.time)

    // Only there once there is something to clear, and holding its place when
    // there is not, so the row does not resize under a thumb.
    const clear = Button('بدون ساعت')
    clear.addClass(style.clear)
    const syncClear = () => clear.style({ visibility: draft.time ? '' : 'hidden' })

    input.on('input', ({ value }: { value: string }) => {
        draft.time = value
        syncClear()
        base.emit('change')
    })

    clear.on('click', () => {
        draft.time = ''
        input.setValue('')
        syncClear()
        base.emit('change')
    })

    syncClear()
    row.append(input, clear)

    return base
}
